<template>
  <div class="contractManageList">
    <div class="filters">
      <el-form :inline="true">
        <el-collapse v-model="activeNames">
          <el-collapse-item name="1" :title="$t('lang.lab_selete')">
            <el-form-item class="selee">
              <el-select v-model="contract1" @change="getcontractList2">
                <el-option key :label="$t('lang.lab_contractChoose1')" :value="0"></el-option>
                <el-option
                  v-for="(item,index) in contractList1"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="selee">
              <el-select v-model="contract2" @change="getcontractList3">
                <el-option key :label="$t('lang.lab_contractChoose2')" :value="0"></el-option>
                <el-option
                  v-for="(item,index) in contractList2"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="selee">
              <el-select v-model="contract3">
                <el-option key :label="$t('lang.lab_contractChoose3')" :value="0"></el-option>
                <el-option
                  v-for="(item,index) in contractList3"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('lang.lab_dataBegin')" class="key-data">
                <el-date-picker
                  v-model="dataListQD"
                  :format="$t('lang.lab_DATA')"
                  value-format="timestamp"
                  type="daterange"
                  :range-separator="$t('lang.lab_to')"
                  :start-placeholder="$t('lang.lab_startDate')"
                  :end-placeholder="$t('lang.lab_endDate')">
                </el-date-picker>
            </el-form-item>
            <el-form-item :label="$t('lang.lab_dataHT')" class="key-data">
                <el-date-picker
                  v-model="dataListHT"
                  :format="$t('lang.lab_DATA')"
                  value-format="timestamp"
                  type="daterange"
                  :range-separator="$t('lang.lab_to')"
                  :start-placeholder="$t('lang.lab_startDate')"
                  :end-placeholder="$t('lang.lab_endDate')">
                </el-date-picker>
            </el-form-item>
            <el-form-item :label="$t('lang.lab_dataZB')" class="key-data">
                <el-date-picker
                  v-model="dataListZB"
                  :format="$t('lang.lab_DATA')"
                  value-format="timestamp"
                  type="daterange"
                  :range-separator="$t('lang.lab_to')"
                  :start-placeholder="$t('lang.lab_startDate')"
                  :end-placeholder="$t('lang.lab_endDate')">
                </el-date-picker>
            </el-form-item>
            <el-form-item :label="$t('lang.lab_dataSK')" class="key-data">
              <el-date-picker
                v-model="dataListSK"
                :format="$t('lang.lab_DATA')"
                value-format="timestamp"
                type="daterange"
                :range-separator="$t('lang.lab_to')"
                :start-placeholder="$t('lang.lab_startDate')"
                :end-placeholder="$t('lang.lab_endDate')">
              </el-date-picker>
            </el-form-item>
            <br>
            <el-form-item class="detp-type">
              <el-select v-model="chooseDept" :title="chooseDept">
                <el-option key :label="$t('lang.lab_chooseDept')" value=''></el-option>
                <el-option
                  v-for="(item,index) in chooseDeptList"
                  :key="index.DeptName"
                  :label="item.DeptName"
                  :value="item.DeptName"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="detp-type">
              <el-select v-model="chooseContract">
                <el-option key :label="$t('lang.lab_please_Select') + $t('lang.lab_contractLOption')" value=''></el-option>
                <el-option
                  v-for="(item,index) in $t('lang.CONTRACT.STATES')"
                  :key="index"
                  :label="item.label"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="key-input">
              <el-input :placeholder="$t('lang.lab_please_Input') + $t('lang.lab_contractLName')" v-model="keyword"></el-input>
            </el-form-item>
            <el-button type="primary" @click="commit()">{{$t('lang.btn_search')}}</el-button>
            <el-button type="primary" @click="callMe()">{{$t('lang.lab_contractCall')}}</el-button>
          </el-collapse-item>
        </el-collapse>
      </el-form>
    </div>
    <el-card>
      <el-button slot="header" size="medium" type="primary" @click="add()">{{$t('lang.lab_newContract')}}</el-button>
      <el-table
        :height="tableData.length > 0 ? require('@/config/enum').tableheight529 : require('@/config/enum').tableheight109"
        :data="tableData"
        class="wid100"
        :row-class-name="tableRowClassName"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55" :selectable="selectable"></el-table-column>
        <el-table-column
          type="index"
          :index="indexMethod" align="center"
          :label="$t('lang.lab_index')"
          width="100px"
        ></el-table-column>
        <el-table-column prop="id" label="ID" width="100px"></el-table-column>
        <el-table-column :label="$t('lang.lab_deptName')" width="170px">
          <template slot-scope="scope">
            <el-tooltip
              placement="top"
              effect="light"
              v-if="scope.row.deptName&&scope.row.deptName.length> require('@/config/enum').tableDatamaxlength10"
              :disabled="false"
            >
              <div slot="content">
                <span >
                  {{ scope.row.deptName }}
                </span>
              </div>
              <div>
                {{ scope.row.deptName.substring(0, require('@/config/enum').tableDatamaxlength10) | valueIsNull }}
                <span
                  v-if="scope.row.deptName.length>require('@/config/enum').tableDatamaxlength10"
                >...</span>
              </div>
            </el-tooltip>
            <el-tooltip placement="top" effect="light" v-else :disabled="true">
              <div>{{ scope.row.deptName | valueIsNull }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="contractType1.name" :label="$t('lang.lab_contractType')" width="120px"></el-table-column>
        <el-table-column prop="name" :label="$t('lang.lab_contractLName')" width="175px">
          <template slot-scope="scope">
            <el-tooltip
              placement="top"
              effect="light"
              v-if="scope.row.name&&scope.row.name.length> require('@/config/enum').tableDatamaxlength9"
              :disabled="false"
            >
              <div slot="content">
                <span >
                  {{ scope.row.name }}
                </span>
              </div>
              <div>
                {{ scope.row.name.substring(0, require('@/config/enum').tableDatamaxlength9) | valueIsNull }}
                <span
                  v-if="scope.row.name.length>require('@/config/enum').tableDatamaxlength9"
                >...</span>
              </div>
            </el-tooltip>
            <el-tooltip placement="top" effect="light" v-else :disabled="true">
              <div>{{ scope.row.name | valueIsNull }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column :label="$t('lang.lab_contractLId')" width="200px">
          <template slot-scope="scope">
            <el-tooltip
              placement="top"
              effect="light"
              v-if="scope.row.contractNo&&scope.row.contractNo.length> require('@/config/enum').tableDatamaxlength"
              :disabled="false"
            >
              <div slot="content">
                <span >
                  {{ scope.row.contractNo }}
                </span>
              </div>
              <div>
                {{ scope.row.contractNo.substring(0, require('@/config/enum').tableDatamaxlength) | valueIsNull }}
                <span
                  v-if="scope.row.contractNo.length>require('@/config/enum').tableDatamaxlength"
                >...</span>
              </div>
            </el-tooltip>
            <el-tooltip placement="top" effect="light" v-else :disabled="true">
              <div>{{ scope.row.contractNo | valueIsNull }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column :label="$t('lang.lab_contractLbeginTime')" >
          <template slot-scope="scope">
            {{ scope.row.startDate | timeYMD }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('lang.lab_contractLEndTime')" >
          <template slot-scope="scope">
            {{ scope.row.endDate | timeYMD }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('lang.lab_contractLCount')" width="100px">
          <template slot-scope="scope">
            <span>{{scope.row.maxCharge}}/{{scope.row.installmentCount}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="payState" :label="$t('lang.lab_contractLPrice')" width="100px">
          <template slot-scope="scope">
            <span v-if="scope.row.payState === 1">{{$t('lang.lab_payMoney')}}</span>
            <span v-if="scope.row.payState === 0">{{$t('lang.lab_getMoney')}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('lang.lab_contractLevel')" width="100px">
          <template slot-scope="scope">
            <span v-if="scope.row.state === 0" :class="{ 'red': scope.row.isOverStartDate === 1 }">{{$t('lang.lab_noStart')}}</span>
            <span v-if="scope.row.state === 1">{{$t('lang.lab_INGnow')}}</span>
            <span v-if="scope.row.state === 2">{{$t('lang.lab_paperefinsh')}}</span>
            <span v-if="scope.row.state === 3">{{$t('lang.lab_outData')}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="operation" :label="$t('lang.lab_operation')" :width="require('@/config/enum').opr_width2">
          <template slot-scope="scope">
            <el-button @click="edit(scope.row.id)">{{$t('lang.btn_modify')}}</el-button>
            <el-button @click="recordPrice(scope.row.id, scope.row.installmentCount)">{{$t('lang.lab_recordPrice')}}</el-button>
            <el-button @click="callPerson(scope.row.id)" v-if="scope.row.txMobile === ''">{{$t('lang.lab_callMe')}}</el-button>
            <el-button @click="callPerson(scope.row.id)" v-if="scope.row.txMobile != ''">{{$t('lang.lab_callMeReady')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNo"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout=" sizes, prev, pager, next, jumper"
        :page-count="pageCount"
      />
    </el-card>
    <el-dialog
      :visible.sync="show"
      :close-on-click-modal="false"
      center
      top="130px"
      width="600px"
      :title="changeTitle"
      @closed="handleDialogClosed"
    >
      <el-form ref="form" :model="form" :label-width="require('@/config/enum').c_ws4" :label-suffix="require('@/config/enum').c_colon" :rules="rules" class="form_show">
        <el-form-item :label="$t('lang.lbl_duties_mobile')" prop="mobel">
          <el-input v-model="form.mobel" :placeholder="$t('lang.lab_please_Input') + $t('lang.lbl_duties_mobile')" :disabled="callInputDis"></el-input>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_callMeTime')" prop="remindData">
          <div class="block">
            <el-date-picker :picker-options="pickerOptions" :disabled="callInputDis" v-model="form.remindData" type="date" value-format="timestamp" :placeholder="$t('lang.lab_please_Select') + $t('lang.lab_callMeTime')" class="input"></el-date-picker>
          </div>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_callContent')" prop="remindNote">
          <el-input v-model="form.remindNote" :placeholder="$t('lang.lab_please_Input') + $t('lang.lab_callContent')" :disabled="callInputDis" type="textarea"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="rest('form')" class="cancel" v-if="!callInputDis">{{$t('lang.btn_rest')}}</el-button>
        <el-button type="primary" @click="addRemind('form')" v-if="!callInputDis">{{$t('lang.btn_save')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
/**
 *@ClassName:contractManageList
 *@Description:合同管理
 *@author:刘彦辰
 *@Copyright:格众科技
 *@date:2020-03-30
 */
export default {
  name:'/manage/main.contract',
  data() {
    var phone = /^1(?:3\d|4[4-9]|5[0-35-9]|6[67]|7[013-8]|8\d|9\d)\d{8}$/
    var isPhone = (rule, value, callback) => {
      if (value === '') {
        callback(
          new Error(
            this.$i18n.t('lang.lab_please_Input') +
              this.$i18n.t('lang.lbl_duties_mobile')
          )
        )
      } else if (!phone.test(value)) {
        callback(
          new Error(this.$i18n.t('lang.lab_inputDutyPersonPhoneIsTrue'))
        )
      } else {
        callback()
      }
    }
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now()
        }
      },
      pageCount: 0, // 总页数
      pageNo: 1, // 页数
      pageSize: 10, // 每页显示数量
      activeNames: ['1'], // 展开关闭
      tableData: [],
      keyword: '', // 关键字查询
      contract1: 0, // 合同1级分类值
      contractList1: [], // 合同1级分类列表
      contract2: 0, // 合同2级分类值
      contractList2: [], // 合同2级分类列表
      contract3: 0, // 合同3级分类值
      contractList3: [], // 合同3级分类列表
      type: 1, // 获取列表的标识符
      show: false, // 提醒的弹框
      changeTitle: '', // 弹框的title
      dataListQD: '', // 合同日期绑定的数组
      dataListHT: '', // 签订日期绑定的数组
      dataListZB: '', // 质保日期绑定的数组
      dataListSK: '', // 收款日期绑定的数组
      chooseDept: '', // 条件查询的部门id
      multipleSelection: [], // 多选框
      moreId: [], // 复选框选择多个时，设置提醒
      chooseDeptList: [], // 条件查询的部门列表
      chooseContract: '', // 合同状态id
      callInputDis: false, // 提醒时，是否为已提醒
      callMoreButtom: false, // 是否点击了多个设置提醒
      commitname: require('@/config/enum').commitname,
      postAuditListcheckbox: require('@/config/enum').postAuditListcheckbox, // 是否隐藏复选框
      form: {
        mobel: '', // 弹框电话
        remindNote: '', // 弹框内容
        remindData: '', // 弹框日期
        remindId: '' // 此条数据的id
      },
      rules: {
        mobel: [
          { required: true, validator: isPhone, trigger: 'blur' }
        ],
        remindNote: [
          { required: true, message: this.$i18n.t('lang.lab_please_Input') + this.$i18n.t('lang.lab_callContent'), trigger: 'blur' }
        ],
        remindData: [
          { required: true, message: this.$i18n.t('lang.lab_please_Select') + this.$i18n.t('lang.lab_callMeTime'), trigger: 'blur' }
        ]
      },
    }
  },
  created() {
    setTimeout(() => {
       window.localStorage.setItem('editContractform', '')
       window.localStorage.setItem('editContractsaveData', '')
    }, 200)
    this.getTablelist()
    this.getcontractList1()
    this.getchooseDeptList()
  },
  activated(){
    this.getTablelist()
    this.getcontractList1()
    this.getchooseDeptList()
  },
  methods: {
    // ID序号功能
    indexMethod(index) {
      return (this.pageNo - 1) * this.pageSize + index + 1
    },
    // 根据条件隐藏复选框
    selectable(row, index) {
      if (row.txMobile != '') {
        return false
      } else {
        return true
      }
    },
    // 查询
    commit() {
      this.pageNo = 1
      this.getTablelist()
    },
    // 提醒
    callPerson(id) {
      this.changeTitle = this.$i18n.t('lang.lab_putRedmin')
      this.form.remindId = id
      this.form.remindNote = ''
      this.form.remindData = ''
      this.form.mobel = ''
      let loading = this.$loading()
      this.$get(`/contractById/` + id).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            if (res.contract.txMobile != '') {
              this.form.remindNote = res.contract.txNote
              this.form.remindData = res.contract.txDate
              this.form.mobel = res.contract.txMobile
              this.callInputDis = true
            } else {
              this.callInputDis = false
            }
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
      this.show = true
    },
    // 提醒弹框保存
    addRemind(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          let params
          if (this.callMoreButtom) {
            params = {
              ContractId: this.moreId.toString(),
              Mobile: this.form.mobel,
              RemindNote: this.form.remindNote,
              RemindDate: this.form.remindData
            }
          } else {
            params = {
              ContractId: this.form.remindId,
              Mobile: this.form.mobel,
              RemindNote: this.form.remindNote,
              RemindDate: this.form.remindData
            }
          }
          let loading = this.$loading()
          this.$post(`/contractRemind`, params).then(
            res => {
              loading.close()
              if (res && res.errCode === 0) {
                this.$message.success(this.$i18n.t('lang.lab_save_success'))
                this.show = false
                this.moreId = []
                this.callMoreButtom = false
                this.commit()
              }
            },
            error => {
              loading.close()
              this.$message.error(error)
            }
          )
        } else {
          return false
        }
      })
    },
    rest(form) {
      this.$refs[ form ].resetFields()
      this.form.remindData = ''
      this.form.remindNote = ''
      this.form.mobel = ''
      this.form.id = ''
    },
    // 合同管理列表
    getTablelist() {
      let loading = this.$loading()
      var startQD = ''
      var endQD = ''
      if (this.dataListQD != null) {
        if (this.dataListQD.length > 0) {
          startQD = this.dataListQD[0]
          endQD = this.dataListQD[1]
        }
      }
      var startHT = ''
      var endHT = ''
      if (this.dataListHT != null) {
        if (this.dataListHT.length > 0) {
          startHT = this.dataListHT[0]
          endHT = this.dataListHT[1]
        }
      }
      var startZB = ''
      var endZB = ''
      if (this.dataListZB != null) {
        if (this.dataListZB.length > 0) {
          startZB = this.dataListZB[0]
          endZB = this.dataListZB[1]
        }
      }
      var startSK = ''
      var endSK = ''
      if (this.dataListSK != null) {
        if (this.dataListSK.length > 0) {
          startSK = this.dataListSK[0]
          endSK = this.dataListSK[1]
        }
      }
      let url = `/contract?pageNo=${this.pageNo}&pageSize=${this.pageSize}&ContractTypeId1=${this.contract1}&ContractTypeId2=${this.contract2}&ContractTypeId3=${this.contract3}&Name=${this.keyword}&startTsQD=${startQD}&endTsQD=${endQD}&startTsHT=${startHT}&endTsHT=${endHT}&startTsZB=${startZB}&endTsZB=${endZB}&startTsSFK=${startSK}&endTsSFK=${endSK}&DeptName=${this.chooseDept}&State=${this.chooseContract}`
      this.$get(url).then(res => {
        loading.close()
        if (res && res.errCode === 0) {
          this.tableData = res.list
          this.pageCount = res.pageCount
        }
      },
      error => {
        loading.close()
        this.$message.error(error)
      })
    },
    callMe() {
      this.changeTitle = this.$i18n.t('lang.lab_putRedmin')
      if (this.moreId.length === 0) {
        this.$message.error(this.$i18n.t('lang.lab_selOne'))
      } else {
        this.callMoreButtom = true
        this.show = true
      }
    },
    // 记账
    recordPrice(id, count) {
      console.log(count)
      if (count === '') {
        this.$message.warning(this.$i18n.t('lang.lab_lessOne'))
      } else {
        this.$router.push({ name: 'setReminder', query: { id: id, count: count } })
      }
    },
    // 列表隔行变色
    tableRowClassName({ row, rowIndex }) {
      return rowIndex % 2 === 0 ? 'row-dark' : ''
    },
    // 翻页
    handleCurrentChange(val) {
      this.pageNo = val
      this.getTablelist()
    },
    // 切换每页显示多少数据
    handleSizeChange(val) {
      this.pageNo = 1
      this.pageSize = val
      this.getTablelist()
    },
    // 获取部门列表
    getchooseDeptList() {
      this.type = 1
      this.$get(`/hr/getDeptNameList`).then(res => {
        this.chooseDeptList = res
      },
      error => {
        this.$message.error(error)
      })
    },
    // 获取一级合同分类列表
    getcontractList1() {
      let loading = this.$loading()
      this.type = 1
      this.$get(`/contractTypes?type=${this.type}&pageSize=999&pageNo=1`).then(res => {
        loading.close()
        if (res && res.errCode === 0) {
          this.contractList1 = res.list
        }
      },
      error => {
        loading.close()
        this.$message.error(error)
      })
    },
    // 获取二级合同分类列表
    getcontractList2() {
      this.type = 2
      this.contract2 = 0
      this.contractList2 = []
      this.contract3 = 0
      this.contractList3 = []
      let loading = this.$loading()
      this.$get(`/contractTypes?type=${this.type}&Pid=${this.contract1}&pageSize=999&pageNo=1`).then(res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.contractList2 = res.list
            if (this.contract1 === 0) {
              this.contract2 = 0
              this.contractList2 = []
              this.contract3 = 0
              this.contractList3 = []
            }
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 获取三级合同分类列表
    getcontractList3() {
      let loading = this.$loading()
      this.type = 3
      this.contract3 = 0
      this.contractList3 = []
      this.$get(`/contractTypes?type=${this.type}&Pid=${this.contract2}&pageSize=999&pageNo=1`).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.contractList3 = res.list
            if (this.contract2 === 0) {
              this.contract3 = 0
              this.contractList3 = []
            }
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 弹框监听关闭
    handleDialogClosed() {
      this.form.remindNote = ''
      this.form.remindData = ''
      this.form.mobel = ''
      this.$refs.form.clearValidate()
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
      let idList = []
      this.multipleSelection.forEach(element => {
        idList.push(element.id)
      })
      this.moreId = idList
    },
    add() {
      window.localStorage.setItem('editContractform', '')
      window.localStorage.setItem('editContractsaveData', '')
      this.$router.push({ name: 'editContract' })
    },
    edit(id) {
      window.localStorage.setItem('editContractform', '')
      window.localStorage.setItem('editContractsaveData', '')
      this.$router.push({ name: 'editContract', query: { id: id } })
    },
  }
}
</script>

<style lang="scss">
  .contractManageList {
    .detp-type {
      .el-form-item__content {
        width: 100%;
        .el-select{
          width: 315px;
          .el-input__inner {
            min-width: 100px;
          }
        }
      }
    }
    .el-collapse-item__header{
      font-size: 16px;
      padding-left: 0%;
      margin-left: 0px;
      border-bottom:0px;
    }
    .el-collapse {
      border-top:0px;
    }
    .el-collapse-item__wrap {
      will-change: height;
      background-color: #FFF;
      overflow: hidden;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      border-bottom: 0px solid #EBEEF5;
    }
    .key-input {
      width: 30%;
      .el-form-item__content {
        width: 100%;
        .el-input__inner {
          min-width: 100px;
        }
      }
    }
    .key-data {
      width: 43%;
      .el-form-item__content {
        width: 85%;
        .el-range-editor {
          width: 100%;
        }
      }
    }
    .selee {
      width: 28%;
      .el-form-item__content {
        width: 100%;
        min-width: 180px;
        .el-select {
          width: 100%;
          min-width: 180px;
          .el-input--suffix {
            min-width: 180px;
          }
        }
      }
    }
    .key-dept {
      width: 50%;
      .el-form-item__content {
        width: 100%;
        .el-select {
          width: 100%;
        }
      }

    }
    .red {
      color: red;
    }
  }
</style>